export default "__VITE_ASSET__CfTUBCqd__"